import { useMemo } from "react";

import { Breadcrumbs } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CountryIcon, GAConnectedPropertyInfo, onCrumbClick } from "app/pages/activation";
import type { IActivationData } from "app/pages/benchmark-tracker/queries/useUserdataActivationQuery";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import DurationFilter from "../Filters/Duration";
import { GAConnectContainer } from "../GaConnectContainer";
import { ReportActions } from "../ReportActions/ReportActions";

import * as SC from "./styles";

interface IHeaderProps {
    currentActivationSet?: IActivationData;
    isLoading: boolean;
    isViewerMode?: boolean;
}

export const Header = ({ currentActivationSet, isLoading, isViewerMode }: IHeaderProps) => {
    const { granularity, country } = proNavigator.getParams();

    const crumbsList = useMemo(() => {
        return [
            {
                state: "activation-home",
                title: translate("common.home"),
            },
            ...(currentActivationSet
                ? [
                      {
                          state: "activation-project",
                          title: currentActivationSet?.name,
                          params: { key: currentActivationSet?.id, timeGranularity: granularity },
                      },
                  ]
                : []),
            {
                state: "",
                title: translate("bt.home.page.title"),
            },
        ];
    }, [currentActivationSet, granularity]);

    return (
        <SC.Header>
            <Breadcrumbs
                isLoading={isLoading}
                list={crumbsList}
                onClick={onCrumbClick}
            />

            <Stack gap="4px">
                <SC.Section>
                    <SC.Title>
                        {translate("bt.report.header.title")}

                        <DurationFilter />
                        <CountryIcon country={country} />
                    </SC.Title>

                    <SC.ActionsContainer>
                        <ReportActions isViewerMode={isViewerMode ?? false} />

                        {!isViewerMode && !isLoading && currentActivationSet?.id ? (
                            <GAConnectContainer
                                activationId={currentActivationSet.id}
                                isGaSource={currentActivationSet?.trafficSource === "GA"}
                            />
                        ) : null}
                    </SC.ActionsContainer>
                </SC.Section>

                {currentActivationSet?.trafficSource === "GA" ? (
                    <Flex justifyContent="end">
                        <GAConnectedPropertyInfo activationId={currentActivationSet.id} />
                    </Flex>
                ) : null}
            </Stack>
        </SC.Header>
    );
};

Header.displayName = "Header";
